module.exports = __webpack_public_path__ + "img/HNTE.b6846a97.jpg";